// The lead list narrows to one lead through `?lead=<_id>` (see
// views/admin/lead-v2/useFilteredQueryParams.js). Shared by the toast button
// and the native-push click so the two cannot point at different URLs.
export const leadUrl = (leadId) => `/lead?lead=${encodeURIComponent(leadId)}`;
